import { isOpenCatalogedModal } from "@/atoms/item/is-open-cataloged-modal";
import { itemPageState } from "@/atoms/item/item-page-state";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { itemService } from "@/services/item-service";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { Button, Modal } from "flowbite-react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { GrayExclamationCircleIcon } from "../icon/GrayExclamationCircleIcon";
import { Body16Regular } from "../typography/Body16Regular";

export const IsCatalogedModal = () => {
  const [isOpenModal, setIsOpenModal] = useRecoilState<
    ItemDetailDto | undefined
  >(isOpenCatalogedModal);

  const setItemPage = useSetRecoilState(itemPageState);
  const setToast = useSetRecoilState(toastState);

  const closeModal = () => {
    setIsOpenModal(undefined);
  };

  const handleSubmit = async () => {
    try {
      if (!isOpenModal) {
        return;
      }
      const manageResponse = await itemService.manage(isOpenModal.id, {
        isCataloged: false,
      });
      if (!manageResponse.ok) {
        return;
      }
      const getByIdResponse = await itemService.getById({ id: isOpenModal.id });
      if (!getByIdResponse.ok) {
        return;
      }
      console.log(getByIdResponse.data);
      setItemPage((prev) => ({
        ...prev,
        contents: prev.contents.map((item) =>
          item.id === getByIdResponse.data.id ? getByIdResponse.data : item
        ),
      }));
      setToast({
        show: true,
        messages: ["상태를 전환했습니다."],
      });
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal size="md" show={true} onClose={closeModal}>
      <Modal.Header className="pt-[10px] px-[10px] h-[36px] border-none"></Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex flex-col items-center box-border py-[20px] gap-[20px]">
          <div className="w-[42px] h-[42px] flex items-center justify-center">
            <GrayExclamationCircleIcon size={35} />
          </div>
          <div className="flex flex-col items-center">
            <Body16Regular className="text-semantic-text-secondary">
              카탈로그에 상품을 안보이게 전환하시겠어요?
            </Body16Regular>
            <Body16Regular className="text-semantic-text-secondary">
              공식홈페이지에서 해당 상품을 확인할 수 없게 됩니다.
            </Body16Regular>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="pt-0 border-none">
        <div className="flex gap-[16px] items-center justify-center w-full">
          <Button
            size="sm"
            color={ButtonColor.TRANSPARENT_OUTLINE}
            onClick={closeModal}
          >
            취소하기
          </Button>
          <Button size="sm" color={ButtonColor.PRIMARY} onClick={handleSubmit}>
            전환하기
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
